<template>
    <rkm-layout-body title="Lista de exportação">
        <template v-slot:actions>
            <rkm-button
                @click="$refs.Modal.open()"
                authorize="store-bpa-exportacao"
                color="primary"
            >
                Exportar
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List ref="List" />
        </rkm-layout-content>

        <Modal
            @save="$refs.List.refresh()"
            ref="Modal"
        />
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/bpa/exportacao/List'
import Modal from '@/components/bpa/exportacao/Modal'

export default {
    components: {
        List,
        Modal
    },
}
</script>